/* istanbul ignore file */
import BudgetLink from './BudgetLink';

const BudgetChildLinkField = ({ value = {} }: { value?: any }) => {
  return <BudgetLink id={value.id} name={value.name} />;
};

export default BudgetChildLinkField;
